import React, { useState } from 'react';
import { Label, Alert, Input,Button } from '@americanexpress/dls-react';
import { DateOfBirth,Loading } from '../../components';
import { UserProvider } from '../../components/ContextComponent/UserContext';
import { useHistory } from "react-router-dom";

function Login(props) {
    const [formData, setFormData] = useState({lastName: '', dateOfBirth: '' });
    const [errorData, setErrorData] = useState({ lastNameRequired: '', dateOfBirthRequired: '' });
    const [invalid, setInvalid] = useState(false);
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const changeLastNameHandler = (event) => {
        setFormData({ ...formData, lastName: event.target.value });
    };
    const blurLastNameHandler = (event) => {
        if (event.target.value === '') {
            setErrorData({ ...errorData, lastNameRequired: true });
        } else { setErrorData({ ...errorData, lastNameRequired: false }); }
    }

    const clickHandler = async (e) => {
        setLoading(true);
        e.preventDefault();

        let lstForm = {
            "AppID": props.id,
            "LastName": formData.lastName,
            "DateOfBirth": formData.dateOfBirth           
        };
        let jsonData = JSON.stringify(lstForm);

        await fetch(`/api/Prospect/LeadDetails`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: jsonData
        }).then(async response => {
            if (response.status === 200) {
                const data = await response.json();
                history.push(
                    `/TwoStageForm/${props.productName}`,
            JSON.stringify({data:data}));
            }
            else {
                setLoading(false);
                setInvalid(true);
            }
        });
    }

    return (       
        <UserProvider value={{ formData, setFormData, errorData, setErrorData }}>
            {loading && (
                <Loading showModal={true} />
            )}
            <div className="text-align-center pad-2-tb">
                <h1 className="text-uppercase">Welcome Back</h1>
            </div>
            <div className="text-align-center pad-1-b">
                Thank you for continuing your application for {props.cardDisplayName}
            </div>
            <div className="text-align-center pad-1-b">
                Please enter the below information to retrieve your application from where you left off.
            </div>
            <div className="row pad-1-t">
                <div className="col-md-5 pad-1">
                    <Label className="label-1" htmlFor="LastName">Last Name</Label>
                    <Input
                        id="LastName"
                        name="LastName"
                        aria-describedby="LastName"
                        required
                        maxLength={15}
                        onBlur={blurLastNameHandler} onChange={changeLastNameHandler} value={formData.lastName}
                    />
                    <Alert id="lastName-Null" show={errorData.lastNameRequired}>Please provide your last name </Alert>
                </div>
                <div className="col-md-7 pad-1">
                    <DateOfBirth />
                </div>
                <Alert id="Invalid-Null" show={invalid}>Invalid last name or date of birth</Alert>                
            </div>
            <div className="flex flex-column flex-align-items-center pad-responsive">
                <Button aria-label="Submit" type="submit" styleType="primary"
                    onClick={clickHandler}
                >Continue</Button>
            </div>
        </UserProvider>
    );
}

export default Login;